import axios from "axios";
import * as actionTypes from "./actionTypes";
import { API_REGISTRATION, API_LOGIN } from "../../constants";
import { setAuthToken } from "../../utilities/requests";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (token, user, email) => {
  localStorage.setItem("token", token);
  setAuthToken(token);
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token,
    user: user,
    email: email,
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error,
  };
};

const LOGIN_CREDENTIALS_ERROR_MESSAGE =
  "The username or password looks incorrect. Please check your login details and try again.";
const LOGIN_NETWORK_ERROR_MESSAGE =
  "We couldn't reach Rightwork. Please check your connection and try again.";
const LOGIN_SERVER_ERROR_MESSAGE =
  "Rightwork couldn't complete login right now. Please try again in a moment.";

const isLoginCredentialsError = (error) => {
  const status = error.response && error.response.status;
  return status === 400 || status === 401;
};

const getLoginErrorMessage = (error) => {
  const status = error.response && error.response.status;

  if (isLoginCredentialsError(error)) {
    return LOGIN_CREDENTIALS_ERROR_MESSAGE;
  }

  if (!error.response) {
    return LOGIN_NETWORK_ERROR_MESSAGE;
  }

  if (status >= 500) {
    return LOGIN_SERVER_ERROR_MESSAGE;
  }

  return LOGIN_SERVER_ERROR_MESSAGE;
};

export const logout = () => {
  localStorage.clear();
  // ensure any cached Stream Chat token is removed
  localStorage.removeItem("streamUserToken");
  setAuthToken(null);
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

export const checkAuthTimeout = (expirationTime) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(logout());
    }, expirationTime * 1000000 * 24 * 1);
  };
};

export const authLogin = (username, password) => {
  return (dispatch) => {
    dispatch(authStart());
    axios
      //.post("http://localhost:8000/api/dj-rest-auth/login/", {
      .post(API_LOGIN, {
        username: username,
        password: password,
      })
      .then((res) => {
        const token = res.data.key;
        const expirationDate = new Date(
          new Date().getTime() + 3600 * 100000 * 24 * 1
        );
        localStorage.setItem("token", token);
        localStorage.setItem("user", username);
        localStorage.setItem("email", username);
        localStorage.setItem("expirationDate", expirationDate);
        dispatch(authSuccess(token, username, username));
        dispatch(checkAuthTimeout(3600));
      })
      .catch((err) => {
        if (!isLoginCredentialsError(err)) {
          alert(getLoginErrorMessage(err));
          dispatch(authFail(err));
          return;
        }

        axios
          //.post("http://localhost:8000/api/dj-rest-auth/login/", {
          .post(API_LOGIN, {
            email: username,
            password: password,
          })
          .then((res) => {
            const token = res.data.key;
            const expirationDate = new Date(
              new Date().getTime() + 3600 * 100000 * 24 * 1
            );
            localStorage.setItem("token", token);
            localStorage.setItem("user", username);
            localStorage.setItem("email", username);
            localStorage.setItem("expirationDate", expirationDate);
            dispatch(authSuccess(token, username, username));
            dispatch(checkAuthTimeout(3600));
          })
          .catch((err) => {
            //amplitude.getInstance().logEvent("Login Error");
            alert(getLoginErrorMessage(err));
            dispatch(authFail(err));
          });
      });
  };
};

export const authSignup = (username, email, password1, password2) => {
  return (dispatch) => {
    dispatch(authStart());
    axios
      //.post("http://localhost:8000/api/dj-rest-auth/registration/", {
      .post(API_REGISTRATION, {
        username: username,
        email: email,
        password1: password1,
        password2: password2,
      })
      .then((res) => {
        const token = res.data.key;
        const expirationDate = new Date(
          new Date().getTime() + 3600 * 100000 * 24 * 1
        );
        localStorage.setItem("token", token);
        localStorage.setItem("user", username);
        localStorage.setItem("email", email);
        localStorage.setItem("expirationDate", expirationDate);
        dispatch(authSuccess(token, username, email));
        dispatch(checkAuthTimeout(3600));
      })
      .catch((err) => {
        // console.log(err);
        alert("Please try a different username or password.");
        dispatch(authFail(err));
      });
  };
};

export const authCheckState = () => {
  return (dispatch) => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    const email = localStorage.getItem("email");
    if (token === undefined) {
      dispatch(logout());
    } else {
      const expirationDate = new Date(localStorage.getItem("expirationDate"));
      if (expirationDate <= new Date()) {
        dispatch(logout());
      } else {
        dispatch(authSuccess(token, user, email));
        dispatch(checkAuthTimeout(3600));
      }
    }
  };
};
